const SelectComponent = ({ title, selectItem, value, handleChange, minWidth }) => {
    return (
        <div
            className="selectContainer"
            style={minWidth ? { ['--minw']: `${minWidth}px` } : undefined}
        >
            {title && <label className="selectContainer__label">{title}</label>}
            <div className="selectContainer__wrap">
                <select
                    className="selectContainer__select"
                    value={value}
                    onChange={handleChange}
                >
                    {selectItem.map((item, i) => (
                        <option key={i} value={item.value}>
                            {item.text ?? item.value}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}

export default SelectComponent